import { VREditorSubPanel } from './subpanel.js';

export class VREditorControlPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'controls',
      name: 'Controls',
      allowAddAsset: false
    });

    const editorControlZoom = super.createEditorCheckbox(
      'controls_zoom',
      'Zoom',
      vr.options.controls === 'all' || vr.options.controls.includes('zoom')
    );
    editorControlZoom.change(function () {
      vr.addRemoveControlOption('zoom', this.checked);
    });

    const editorControlAmbient = super.createEditorCheckbox(
      'controls_ambient',
      'Ambient noise',
      vr.options.controls === 'all' || vr.options.controls.includes('ambient')
    );
    editorControlAmbient.change(function () {
      vr.addRemoveControlOption('ambient', this.checked);
    });

    const editorControlDayNight = super.createEditorCheckbox(
      'controls_daynight',
      'Day / night mode',
      vr.options.controls === 'all' || vr.options.controls.includes('daynight')
    );
    editorControlDayNight.change(function () {
      vr.addRemoveControlOption('daynight', this.checked);
    });

    // const editorControlShare = super.createEditorCheckbox(
    //   'controls_share',
    //   'Social Sharing',
    //   vr.options.controls === 'all' || vr.options.controls.includes('share')
    // );
    // editorControlShare.change(function () {
    //   vr.addRemoveControlOption('share', this.checked);
    // });

    const editorControlWelcome = super.createEditorCheckbox(
      'controls_welcome',
      'Welcome',
      vr.options.controls === 'all' || vr.options.controls.includes('welcome')
    );
    editorControlWelcome.change(function () {
      vr.addRemoveControlOption('welcome', this.checked);
    });

    const editorControlFullscreen = super.createEditorCheckbox(
      'controls_fullscreen',
      'Full screen',
      vr.options.controls === 'all' || vr.options.controls.includes('fullscreen')
    );
    editorControlFullscreen.change(function () {
      vr.addRemoveControlOption('fullscreen', this.checked);
    });
  }

  // override
  openPanel(){}
}
